module.exports = __webpack_public_path__ + "static/media/ARQUIVO.4e359ca5.svg";